var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"oweb-root"}},[_c('w-dialog-view'),(_vm.ready)?_c('w-nav'):_vm._e(),(_vm.ready)?_c('w-main'):_vm._e(),(_vm.splash)?_c('w-splash'):_vm._e(),(_vm.frozen)?_c('w-freezer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }